module.exports = __webpack_public_path__ + "static/media/holdin-on.35faabc9.mp3";